import { Link, NavLink, useLocation } from 'react-router-dom';
import './superadmin.css';

interface NavItem {
  label: string;
  to?: string;
  end?: boolean;
  tabKey?: string;
}

interface NavSection {
  title: string;
  items: NavItem[];
}

const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Inicio',
    items: [{ label: 'Resumen general', to: '/admin/overview', end: true }],
  },
  {
    title: 'Gestión',
    items: [
      { label: 'Proyectos', to: '/admin/dashboard?tab=projects', tabKey: 'projects' },
      { label: 'Organizaciones', to: '/admin/dashboard?tab=clients', tabKey: 'clients' },
      { label: 'Usuarios y roles', to: '/admin/users' },
    ],
  },
];

export function NavSidebar(): JSX.Element {
  const { pathname, search } = useLocation();
  const activeTab = new URLSearchParams(search).get('tab');

  return (
    <aside className="sa-sidebar">
      <div className="sa-sidebar-brand">
        <span className="sa-sidebar-brand-label">Consola Territorial</span>
        <span className="sa-sidebar-role-badge">SUPERADMIN</span>
      </div>

      <nav className="sa-sidebar-nav" aria-label="Navegación administrativa">
        {NAV_SECTIONS.map(section => (
          <div key={section.title} className="sa-nav-section">
            <span className="sa-nav-section-label">{section.title}</span>

            {section.items.map(item => {
              if (!item.to) return null;

              if (item.tabKey) {
                const isDashboard = pathname === '/admin/dashboard';
                const tabMatches =
                  activeTab === item.tabKey ||
                  (item.tabKey === 'projects' && activeTab === null);
                const isActive = isDashboard && tabMatches;

                return (
                  <Link
                    key={item.label}
                    to={item.to}
                    className={`sa-nav-item${isActive ? ' sa-nav-item--active' : ''}`}
                  >
                    {item.label}
                  </Link>
                );
              }

              return (
                <NavLink
                  key={item.label}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `sa-nav-item${isActive ? ' sa-nav-item--active' : ''}`
                  }
                >
                  {item.label}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
}
